@if (visible) {
<div class="fixed inset-0 flex items-center justify-center p-6" [style.z-index]="zIndex">
  <div class="absolute inset-0 bg-[rgba(39,43,52,0.24)]"></div>

  <div [style.width]="width"
    class="relative z-10 bg-light rounded-3xl shadow-custom max-w-full p-4 xs:p-6 border border-[#9AA8BC20] max-h-[98vh] overflow-y-auto overflow-x-hidden"
    [class]="customClass" (click)="stopPropagation($event)" role="dialog" aria-modal="true">
    <!-- Header -->
    @if (showHeader) {
    <div class="flex items-start justify-between w-full">
      <h2 class="font-poppins font-semibold text-[22px] leading-[24px] text-text-primary m-0">{{ title }}
      </h2>
      <button class="text-[10px] text-text-primary" (click)="close()">
        <i class="fi fi-ss-cross text-text-primary"></i>
      </button>
    </div>
    }

    <div #modalContent></div>

    <!-- Footer -->
    @if (showFooter) {
    <div class="mt-6 flex justify-end gap-4 h-12">
      @if (showCancelButton) {
      <app-buttons [type]="cancelButtonType" [text]="cancelButtonText" size="medium" typeButton="button"
        (buttonClick)="close()">
      </app-buttons>
      }
      @if (showConfirmButton) {
      <app-buttons [text]="confirmButtonText" [type]="confirmButtonType" size="medium" typeButton="button" [disabled]="confirmButtonDisabled"
        (buttonClick)="confirm()">
      </app-buttons>
      }
    </div>
    }
  </div>
</div>
}